import React from "react";
import SidebarNavListItem from "./SidebarNavListItem";

const SidebarNavList = ({ pages, preventNavigation,setPreventNavigation, open, handleClick }) => {
  return (
    <React.Fragment>
      {pages.map((page) => (
        <SidebarNavListItem
          open={open}
          preventNavigation={preventNavigation}
          setPreventNavigation={setPreventNavigation}
          handleClick={handleClick}
          key={page.title}
          title={page.title}
          icon={page.icon}
          href={page.href}
          children={page.children ? page.children : ""}
        />
      ))}
    </React.Fragment>
  );
};

export default SidebarNavList;
